export default __webpack_public_path__ + "static/media/img-stats-graf-01.9c6a4361.jpg";